import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";
import { Button } from "./ui/button";
import { LogOut } from "lucide-react";

export const STATUS_STYLES = {
  documents_pending: "bg-slate-100 text-slate-600",
  documents_received: "bg-blue-50 text-blue-700",
  under_verification: "bg-amber-50 text-amber-700",
  verification_failed: "bg-red-50 text-red-700",
  report_locked: "bg-indigo-50 text-indigo-700",
  report_ready: "bg-emerald-50 text-emerald-700",
};

export function StatusPill({ status, label }) {
  return (
    <span data-testid={`status-pill-${status}`} className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide ${STATUS_STYLES[status] || "bg-slate-100 text-slate-600"}`}>
      {label || status}
    </span>
  );
}

export default function PortalShell({ title, subtitle, children, actions }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50" data-testid="portal-shell">
      <header className="glass-nav">
        <div className="mx-auto flex h-16 max-w-7xl items-center gap-4 px-4 sm:px-6 lg:px-8">
          <Link to="/" data-testid="portal-home-link"><Logo height="h-8" /></Link>
          <span className="hidden rounded-md bg-blue-50 px-2 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-blue-700 sm:inline" data-testid="portal-role-badge">
            {user?.role === "builder_admin" ? "Builder Portal" : user?.role === "builder_staff" ? "Builder Staff" : user?.role === "ops" ? "Operations" : "Individual Portal"}
          </span>
          <div className="ml-auto flex items-center gap-3">
            <span className="hidden text-sm text-slate-600 sm:inline" data-testid="portal-user-name">{user?.name}</span>
            <Button variant="outline" size="sm" data-testid="portal-logout-button" onClick={async () => { await logout(); navigate("/"); }}>
              <LogOut className="mr-1.5 h-3.5 w-3.5" /> Log out
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl" data-testid="portal-title">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
          </div>
          {actions}
        </div>
        {children}
      </main>
    </div>
  );
}
